<template>
   <svg
    class="icon"
    :height="size"
    viewBox="0 0 16 16"
    :width="size"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script setup>
import { baseIconProps } from '../base/use-base-icon.js';

defineProps(baseIconProps);

</script>
